module.exports = __webpack_public_path__ + "img/wxPic.79c05c33.jpg";